import styled, { css } from 'styled-components';

import mixin from '../../../_foundations/Mixin';
import Text from '../../Text';

export const TabItem = styled.div`
  ${(props) =>
    props.tabStyle === 'default' &&
    css`
      padding: 0.5rem 0.75rem;
      position: relative;
      cursor: pointer;
      ${mixin.horizontalFlow()}
      & > ${Text} {
        ${mixin.text({ strong: true })}
      }

      ${props.selected
        ? css`
            &:after {
              position: absolute;
              right: 0.125rem;
              bottom: -0.25rem;
              left: 0.125rem;
              border-radius: 0.125rem;
              background: var(--aqua-700);
              height: 0.25rem;
              content: '';
            }
          `
        : css`
            &:hover {
              &:after {
                position: absolute;
                right: 0.125rem;
                bottom: -0.25rem;
                left: 0.125rem;
                border-radius: 0.125rem;
                background: var(--neutral-200);
                height: 0.25rem;
                content: '';
              }
            }
          `}
    `}
`;

export default TabItem;
